import React, { useState } from 'react';
import { Button } from 'antd';
import i18next from 'i18next';
import { Editor } from '@tinymce/tinymce-react';
import { imageUploadHandler } from 'utils/tools';
import { useSelector, useDispatch } from 'react-redux';
import { createComments } from 'redux/comments/actions';

const AddOrderComment = () => {
  const [value, setValue] = useState('');
  const currentOrder = useSelector((state) => state.orders.currentData);
  const dispatch = useDispatch();

  const onSubmit = () => {
    currentOrder?.id &&
      dispatch(
        createComments({
          data: {
            orderId: currentOrder?.backupId,
            content: value,
          },
          options: {
            isBack: false,
          },
        }),
      ).then(({ payload }) => {
        payload?.data?.id && setValue('');
      });
  };

  return (
    <div>
      <Editor
        // bounds=".app"
        // modules={modules}
        onEditorChange={setValue}
        value={value}
        toolbar="undo redo | forecolor backcolor | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link media image"
        init={{
          height: '300',
          images_upload_handler: imageUploadHandler,
        }}
        plugins="code link checklist autolink image imagetools media"
      />
      <br />
      <Button onClick={onSubmit} type="primary">
        {i18next.t('comments.createPage')}
      </Button>
    </div>
  );
};

AddOrderComment.propTypes = {};

export default AddOrderComment;
